// GA4 is loaded site-wide via the gtag snippet in public/index.html (id G-KL8C8NQ85W).
// This helper sends SPA route changes and custom events to that same GA4 property.
const GA4_ID = "G-KL8C8NQ85W";

let loaded = false;

export function loadRemarketing() {
  if (loaded) return;
  loaded = true;
  window.__tenet_analytics = { ga4: GA4_ID, enabled: true };
}

export function trackPageView(path) {
  if (typeof window.gtag !== "function") return;
  window.gtag("event", "page_view", {
    page_path: path,
    page_location: window.location.href,
    page_title: document.title,
  });
}

export function trackEvent(name, params = {}) {
  if (typeof window.gtag === "function") window.gtag("event", name, params);
  window.__tenet_last_event = { name, params };
}
